// TODO: import from @bingads-webui-theme-2018/theme-fluent after PR 3840273 is merged
const mobileDevice = '@media (max-width:600px)';

export const getPerformanceTileStyle = (_, { palette = {} }) => ({
  performanceTileContainer: {
    width: '350px',
    [mobileDevice]: {
      width: 'auto',
    },

    '& .performance-tile': {
      background: palette.white,
      boxShadow: '0 1.6px 3.6px 0 rgba(0,0,0,15%)',
      padding: '16px',

      '& .performance-heading': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: palette.black,
        margin: '0px',
      },

      '& .performance-description': {
        margin: '16px 0 0',
        fontSize: '12px',
      },
      '& .no-performance-view': {
        margin: '16px 0 0',
      },
    },

    '& .performance-note': {
      fontSize: '12px',
      lineHeight: '14px',
      marginTop: '16px',
    },
  },
});
